import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
  { month: 'Jan', awarded: 1200000, pending: 800000 },
  { month: 'Feb', awarded: 1500000, pending: 1200000 },
  { month: 'Mar', awarded: 1800000, pending: 900000 },
  { month: 'Apr', awarded: 2200000, pending: 1500000 },
  { month: 'May', awarded: 1900000, pending: 1100000 },
  { month: 'Jun', awarded: 2500000, pending: 1800000 },
];

export function ContractValueChart() {
  const formatValue = (value: number) => 
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      maximumFractionDigits: 1,
    }).format(value);

  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <h3 className="text-lg font-medium text-gray-900">Contract Value Distribution</h3>
      <div className="mt-2">
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis tickFormatter={formatValue} />
              <Tooltip 
                formatter={(value: number) => formatValue(value)}
                labelStyle={{ color: '#111827' }}
                contentStyle={{ 
                  backgroundColor: 'white',
                  border: '1px solid #e5e7eb',
                  borderRadius: '0.5rem',
                }}
              />
              <Legend />
              <Bar dataKey="awarded" name="Awarded" fill="#8884d8" radius={[4, 4, 0, 0]} />
              <Bar dataKey="pending" name="Pending" fill="#82ca9d" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}